import React from "react";
import { useDraggableSheet } from "../../../helpers/hooks";

import "./SubscriptionCancelConfirmation.scss";
import { fromCentsToPounds } from "../../../helpers/money";

function SubscriptionCancelConfirmation({
    onClose,
    handleCancelSubscription,
    amount,
    full_name

}) {
    const { sheetStyle, overlayHandlers } = useDraggableSheet({ onClose });

    return (
        <div className="cancel-section" {...overlayHandlers}>
            <div
                className={`sheet`}
                style={sheetStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="pull-bar" />

                <div className="cancel-box d-flex f-column my-48 px-24 aic jcc">
                    <h3 className="cancel-title mb-48">
                        Are you sure you want to cancel this {fromCentsToPounds(amount || 0)} monthly contribution to {full_name} ?
                    </h3>

                    <button
                        onClick={handleCancelSubscription}
                        type="button"
                        className="btn confirm-btn red-outline-btn btn-full aic jcc fg-xtred fw-bold py-24 mb-16 d-flex aic jcc"
                    >
                        <span>Yes</span>
                    </button>
                    <button onClick={onClose} className="btn-link btn-dark cancel-btn">
                        No
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SubscriptionCancelConfirmation;
